@if (mapMarker) {
  <div class="legend-content">
    <h4 class="legend-title">{{ 'LAYER.' + mapMarker.name | translate }}</h4>
    <div class="legend-list">
      @for (config of mapMarker.configs; track config.iconMarkerFileName) {
        <div
          class="legend-item fx-layout-row fx-justify-start fx-align-center fx-gap-5">
          <img class="legend-item-icon" [src]="'assets/images/map/' + config.iconMarkerFileName + '.png'"
               alt="{{ config | mapMarkerConfigLabel: mapMarker.type}}"/>
          <div>{{ config | mapMarkerConfigLabel: mapMarker.type }}</div>
        </div>
      }
      <div class="legend-item fx-layout-row fx-justify-start fx-align-center fx-gap-5">
        <img class="legend-item-icon"
             [src]="'assets/images/map/' + mapMarker.defaultIconMarkerFileName + '.png'"
             alt="{{ 'LABEL.NOT_SPECIFIED' | translate }}"/>
        <ng-container>
          <div>{{ 'LABEL.NOT_SPECIFIED' | translate }}</div>
        </ng-container>
      </div>
    </div>
  </div>
}
